import DentalConfigurationTags from '@/modules/dental/common/models/APP/DentalConfigurationTags'
import DentalRelationshipType from '@/modules/dental/common/models/DXP/DentalRelationshipType'
import Configurations from '@/modules/common/common/models/APP/Configuration'
import schema from '@/modules/dental/common/schemas/APP/DentalConfigurationsSchema'
import { validate } from '@/utils/schemaValidatorUtils'
import { DentalMinMaxAges } from './DentalMinMaxAges'
import type TagAlertValue from '@/modules/core/models/TagAlertValue'

export default class DentalConfigurations extends Configurations<DentalMinMaxAges> {
  relationships!: DentalRelationshipType[]
  tags!: DentalConfigurationTags
  startDateHint?: TagAlertValue

  constructor(data?: DentalConfigurations) {
    validate(schema, data)

    super(data)

    if (data?.relationships) {
      this.relationships = data.relationships.map((r) => new DentalRelationshipType(r))
    }

    if (data?.tags) {
      this.tags = new DentalConfigurationTags(data.tags)
    }

    if (data?.hiringMaxAges) {
      this.hiringMaxAges = new DentalMinMaxAges(data.hiringMaxAges)
    }

    if (this.tags && this.tags.customDateAlert) {
      this.startDateHint = this.tags.customDateAlert
    }
  }
}
